/**
 * Common items for forms
 */

export const genderOptions = [
  { value: "Female", label: "Female" },
  { value: "Male", label: "Male" },
  { value: "Nonbinary/Gender Fluid", label: "Nonbinary/Gender Fluid" },
  { value: "Transgender Male", label: "Transgender Male" },
  { value: "Transgender Female", label: "Transgender Female" },
  { value: "Gender Not Listed", label: "Gender Not Listed" },
  { value: "Prefer Not to Answer", label: "Prefer Not to Answer" },
];

export const ethnicityOptions = [
  { value: "Latina/Latino or Hispanic", label: "Latina/Latino or Hispanic" },
  {
    value: "Not Latina/Latino or Hispanic",
    label: "Not Latina/Latino or Hispanic",
  },
  { value: "Prefer Not to Answer", label: "Prefer Not to Answer" },
];

export const raceOptions = [
  {
    value: "American Indian or Alaska Native",
    label: "American Indian/Alaska Native/Indigenous Person",
  },
  {
    value: "Asian",
    label:
      "Asian (including Chinese, Indian, Japanese, Korean, Pakistani, any other Asian Background)",
  },
  {
    value: "Black",
    label:
      "Black (African, Caribbean, any other Black/African/Caribbean background)",
  },
  {
    value: "Native Hawaiian or Other Pacific Islander",
    label: "Native Hawaiian or Other Pacific Islander",
  },
  {
    value: "White",
    label:
      "White (including Eastern/Northern European and any other White background)",
  },
  {
    value: "Middle Eastern or North African",
    label: "Middle Eastern or North African",
  },
  { value: "Race Not Listed", label: "Race Not Listed" },
  { value: "Prefer Not to Answer", label: "Prefer Not to Answer" },
];

export const pronounOptions = [
  { value: "He/Him/His", label: "He/Him/His" },
  { value: "She/Her/Hers", label: "She/Her/Hers" },
  { value: "They/Them/Their", label: "They/Them/Their" },
  { value: "Choice Not Listed", label: "Choice Not Listed" },
  { value: "Prefer Not to Answer", label: "Prefer Not to Answer" },
];

export const sexualOrientationOptions = [
  { value: "Heterosexual", label: "Heterosexual" },
  { value: "LGBTQ+", label: "LGBTQ+" },
  {
    value: "Sexual Orientation Not Listed",
    label: "Sexual Orientation Not Listed",
  },
  { value: "Prefer Not to Answer", label: "Prefer Not to Answer" },
];
